<template>
  <fragment>
    <div class="col-md-4 mb-3">
      <article class="content card p-3 border-0 shadow-sm">
        <p
          class="pb-2 color-blue fw-900 text-uppercase d-flex align-items-center"
        >
          <i class="material-icons pr-2 danger">info</i> Importante
        </p>
        <p class="small">
          A pandemia do Coronavírus trouxe muitas incertezas para empresas,
          principalmente para
          <b class="font-weight-bolder">os micro e pequenos empresários</b>, que
          foram pegos de surpresa com o sumiço dos clientes, e em muitos casos,
          sem reservas financeiras e capital de giro para manter os seus
          negócios.
        </p>
        <p class="small">
          Diante desse cenário, a CDL/BH traz para você, nesse momento em que as
          empresas enfrentam a mais grave crise da história recente,
          consultorias que irão auxiliar diretamente a
          <b class="font-weight-bolder">gestão de crédito e finanças</b> da sua
          empresa.
        </p>
      </article>
    </div>
    <div class="col-md-8">
      <article class="content card p-3 border-0 shadow-sm">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSciaJtJU4Fg9Um5MVWLuW6aGaJyaDoFlOuJkPn6hlXJOClnhg/viewform?embedded=true"
          width="100%"
          height="1600"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          >Carregando…</iframe
        >
      </article>
    </div>
  </fragment>
</template>

<script>
export default {
  name: "epraja",
  data() {
    return {
      filterValue: null,
      filteredValue: null,
      servicos: [],
      detalhe: {},
      loading: false,
      error: null,
      operador: {
        operador: null,
        password: null,
        codigoProduto: null,
      },
      produto: {
        nome: "É pra Já",
        id: "epraja",
      },
      breadcrumb: [
        {
          nome: "É pra Já",
          id: "EpraJa",
        },
      ],
    };
  },
  methods: {
    filter() {},
    detalheProduto(idProduto) {
      this.operador.codigoProduto = idProduto;
      this.loading = true;
      this.$http
        .post("/api/Spc/DetalharProduto", this.operador)
        .then((response) => {
          if (
            response.data == "Operador ou senha inválidos. Tente novamente."
          ) {
            this.error = response.data;
          } else {
            this.detalhe = [...response.data];
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    enviarDadosSPC() {
      this.loading = true;
      this.$http
        .post("/api/Spc/ListarProdutos", this.operador)
        .then((response) => {
          if (
            response.data == "Operador ou senha inválidos. Tente novamente."
          ) {
            this.$toast.open({
              message: response.data,
              type: "error",
            });
          } else {
            this.servicos = [...response.data];
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
.result {
  padding: 40px;
  max-height: 500px;
  overflow-y: auto;
}
.content {
  p {
    line-height: 1.4rem;
  }
}
</style>
